import React, { useState, useRef, useCallback, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
  selectFilteredPOs,
  selectPOFilterVisible,
  selectPOLoading,
} from './store/selectors';
import VirtualList from '../components/VirtualList';
import LoadingSpinner from '../../InitialPage/Sidebar/LoadingSpinner';
import { isHeaderVisible } from 'Core/redux/main/selectors';
import { MODAL_TYPES } from 'Feature/components/app-modals';
import { showModal } from 'Core/redux/main/slice';
import { Eye ,Edit} from 'react-feather';
import { Button, ButtonGroup } from 'react-bootstrap';
import { editPOData } from './store/slice';
import 'sweetalert2/dist/sweetalert2.min.css';
import { format } from 'date-fns';
import { all_routes } from '../../router/all_routes';

const { PO_ADD_EDIT } = MODAL_TYPES;

const POTile = () => {
  const [columnCount, setColumnCount] = useState(6);
  const [columnWidth, setColumnWidth] = useState(300);
  const poTileRef = useRef(null);
  
  const filteredPOs = useSelector(selectFilteredPOs);
  const isLoading = useSelector(selectPOLoading);
  const filterVisible = useSelector(selectPOFilterVisible);
  const headerVisible = useSelector(isHeaderVisible);

  const updateColumnSettings = useCallback(() => {
    if (poTileRef.current) {
      const width = poTileRef.current.offsetWidth;
      let columns = 6;
      if (width < 576) {
        columns = 1;
      } else if (width < 768) {
        columns = 3;
      } else if (width < 992) {
        columns = 5;
      } else {
        columns = 6;
      }
      
      const newColumnWidth = Math.max(width / columns, 200);
      setColumnCount(columns);
      setColumnWidth(newColumnWidth);
    }
  }, []);

  useEffect(() => {
    updateColumnSettings();
    window.addEventListener('resize', updateColumnSettings);
    return () => window.removeEventListener('resize', updateColumnSettings);
  }, [updateColumnSettings, filterVisible, headerVisible]);

  const itemData = filteredPOs.map(po => <POTileItem po={po} key={po.poReceivingID} />);
  const rowCount = Math.ceil(filteredPOs.length / columnCount);

  return (
    <div
      className={`shipment-tile-body ${filterVisible ? 'filter-visible' : ''} ${!headerVisible ? 'header-collapsed' : ''}`}
      ref={poTileRef}
    >
      {(isLoading) && <LoadingSpinner />}
      {
        <VirtualList
          columnCount={columnCount}
          rowCount={rowCount}
          itemData={itemData}
          columnWidth={columnWidth}
          rowHeight={150}
        />
      }
    </div>
  );
};

const POTileItem = ({ po }) => {
  const dispatch = useDispatch();
  const handleView = e => {
    e.preventDefault();
    e.stopPropagation();
    dispatch(editPOData(po.poReceivingID));
    dispatch(showModal(PO_ADD_EDIT, po));
  };
  return (
    <div key={po.poReceivingID} className="po-tile">
      <div
        className={`card p-3 m-2 ${po.isNewlyCreated ? 'border-success' : ''}`}
        style={{
          border: '1px solid #ddd',
          borderRadius: '4px',
          boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
        }}
      >
        <div className="tile-actions" style={{ textAlign: 'right' }}>
          <ButtonGroup size="sm">
            <Button type="button" variant="light" onClick={handleView}>
              <Edit size={16} />
            </Button>
          </ButtonGroup>
        </div>
        <div className="d-flex justify-content-between">
          <div className="d-flex flex-row align-items-center">
            <div className="ms-2 c-details">
              <h6 className="mb-0">{po.poNumber}</h6>
              <span>
                {po.createdDate || 'N/A'}
              </span>
            </div>
          </div>
        </div>
        <div className="mt-1">
          <span
            className="badge"
            style={{
              backgroundColor: po.backgroundColor || '#e0e0e0',
              color: po.textColor || '#000000',
            }}
          >
            {po.status || 'N/A'}
          </span>
        </div>
        <div className="mt-1">
          <h5 className="heading">{po.vendorName}</h5>
        </div>
      </div>
    </div>
  );
};



export default POTile;
